import { sortBy } from 'lodash-es'
import { MenuViewModel, ItemViewModel } from 'store/models/sellModels'
import { MENUSECTION_ALL_ITEMS } from './defaultPOSData'

export function selectDefaultMenuSection(
    selectedMenu: MenuViewModel,
    selectBrandID: string | undefined,
    menuItems: ItemViewModel[],
): string {
    const menuSections = selectedMenu?.menuSections ?? []
    return (
        sortBy(menuSections, ['displayOrder', 'name'])?.find(
            (f) =>
                f.menuSectionId === MENUSECTION_ALL_ITEMS ||
                menuItems.some(
                    (a) =>
                        a.inMenuSections[f.menuSectionId] &&
                        (!selectBrandID || a.brandID === selectBrandID!!),
                ),
        )?.menuSectionId ?? MENUSECTION_ALL_ITEMS
    )
}
